import { useI18n } from 'vue-i18n';
import { format } from 'date-fns';

export const useFormattedDate = () => {
  const { d, locale } = useI18n();

  const shortDateParsed = (startDate) => {
    const date = new Date(startDate + 'T00:00:00');

    let localLocale = locale.value;
    if (localLocale === 'br') {
      localLocale = 'pt-BR';
    }

    return {
      year: d(date, { year: 'numeric' }, localLocale),
      month: d(date, { month: 'short' }, localLocale).replace('.', ''),
      day: d(date, { day: 'numeric' }, localLocale).replace('.', ''),
      weekday: d(date, { weekday: 'long' }, localLocale),
    };
  };

  const defaultFormattedDate = (
    date,
    weekDayFormat = 'short',
    monthFormat = 'short',
  ) => {
    let localLocale = locale.value;
    if (localLocale === 'br') {
      localLocale = 'pt-BR';
    }
    const formattedWeekDay = d(
      date,
      { weekday: weekDayFormat },
      localLocale,
    ).replace('.', '');
    const formattedMonth = d(date, { month: monthFormat }, localLocale).replace(
      '.',
      '',
    );
    return formattedWeekDay + ', ' + formattedMonth + ' ' + format(date, 'd');
  };

  const longFormattedDate = (date) => {
    let localLocale = locale.value;
    if (localLocale === 'br') {
      localLocale = 'pt-BR';
    }
    let formattedWeekDay = d(date, { weekday: 'short' }, localLocale).replace(
      '.',
      '',
    );
    formattedWeekDay =
      formattedWeekDay.charAt(0).toUpperCase() + formattedWeekDay.slice(1);
    let formattedMonth = d(date, { month: 'long' }, localLocale).replace(
      '.',
      '',
    );
    formattedMonth =
      formattedMonth.charAt(0).toUpperCase() + formattedMonth.slice(1);
    //'EEE, MMMM dd, yyyy'
    return (
      formattedWeekDay +
      ', ' +
      formattedMonth +
      ' ' +
      format(date, 'd') +
      ', ' +
      format(date, 'yyyy')
    );
  };

  return {
    shortDateParsed,
    defaultFormattedDate,
    longFormattedDate,
  };
};

export const getWeekNames = (weekFormat = 'narrow', localeInput) => {
  //weekday: How the days of the week will be written. Possible values are long (Wednesday), short (Wed) or narrow (W)
  let localLocale = localeInput;
  if (localLocale === 'br') {
    localLocale = 'pt-BR';
  }

  const { format } = new Intl.DateTimeFormat(localLocale, {
    weekday: weekFormat,
  });
  let weekDays = [...Array(7).keys()].map((day) =>
    format(new Date(2021, 5, day - 1)),
  );

  return {
    weekDays,
  };
};

export const getMonthNames = (monthFormat = 'narrow', localeInput) => {
  let localLocale = localeInput;
  if (localLocale === 'br') {
    localLocale = 'pt-BR';
  }

  const { format } = new Intl.DateTimeFormat(localLocale, {
    month: monthFormat,
  });
  let monthNames = [...Array(12).keys()].map((m) =>
    format(new Date(Date.UTC(2021, m % 12))),
  );

  return {
    monthNames,
  };
};

export const getDaysBetweenDates = (start, end) => {
  const arr = [];
  for (
    const dt = new Date(start);
    dt <= new Date(end);
    dt.setDate(dt.getDate() + 1)
  ) {
    arr.push(new Date(dt));
  }

  return arr;
};

export const formatDate = (date, formatStr = 'EEE, MMM d') => {
  if (!date) return '';
  return format(new Date(date), formatStr);
};
